import * as Ajax from "../../pwa/ajax";
import * as BucketTools from "../common/bucket";
import * as Functions from "../common/functions";
import * as Utilities from "../common/utilities";

const urlBucket = window.config.Statics.BucketUrl;
const urlApiLiveBlog = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiLiveBlog;

const getHora = (fecha) => {
    //"2018-04-14T17:42:19.683" => formato de fecha
    let indexT = fecha.indexOf("T") + 1;
    return fecha.substring(indexT, indexT + 5);
}

const crearlinksFlotantesPostClaves = (posts) => {
    let cantidadPosts = posts.length;
    if (!cantidadPosts > 0)
        return '';

    let html = `<ol class="menu-fixed" data-ids="${posts.length}">`;
    for (var i = 0; i < cantidadPosts; i++) {
        let fecha = new Date(posts[i].fecha);
        html += `<li name="${i}"><span>${fecha.getHours() + ':' + (fecha.getMinutes() < 10 ? '0' : '') + fecha.getMinutes()}</span>${posts[i].titulo}</li>`;
    }

    html += `</ol>`;

    return html;
}

const updatelinksFlotantesPostClaves = (post) => {
    let nodoMenu = document.querySelector('ol.menu-fixed');
    let fecha = new Date(post.fecha);
    let html = `<li name="${nodoMenu.getAttribute('data-ids')}"><span>${fecha.getHours() + ':' + fecha.getMinutes()}</span>${post.titulo}</li>`;

    nodoMenu.setAttribute('data-ids', parseInt(nodoMenu.getAttribute('data-ids')) + 1);
    return html;
}

const calcularTiempoPorPost = (fecha, ocultarFecha = false) => {
    ////"2018-04-14T17:42:19.683" => formato de fecha
    let horaCompleta = getHora(fecha);
    let hora = horaCompleta.substring(0, 2);
    let minutos = horaCompleta.substring(3);

    let fechaLocal = new Date();
    let diferenciaMinutos = Math.abs(Math.round(((fechaLocal.getTime() - Date.parse(fecha)) / 1000 / 60)));
    let diferenciaHoras = Math.abs(Math.round(diferenciaMinutos / 60));
    let tiempoPost = new Date(fecha).toLocaleDateString();
    if (diferenciaMinutos < 59) {
        tiempoPost = `${diferenciaMinutos > 1 ? 'Hace ' + diferenciaMinutos + ' minutos' : "Ahora"}`;
    } else if (diferenciaHoras < 24) {
        tiempoPost = `Hace ` + diferenciaHoras + ` ${diferenciaHoras > 1 ? 'horas' : 'hora'}`;
    }

    return `<div class="hora">
                ${ocultarFecha == false ?  `<span class="count" data-value="${hora}">${hora}</span>:<span class="count" data-value="${minutos}">${minutos}</span>` : ''}                   
                </div>
                <span class="minutos"><i class="icon-circulo"> </i>${tiempoPost}</span>`;
}

const article = (post, postsClave) => {
    let html = "";
    html += `<article id="${post.esClave == 1 ? postsClave : ''}" data-articleId="${post.id}" class="autor">`;
    html += calcularTiempoPorPost(post.fecha, post.ocultarFecha);
    html += `<div class="${post.esClave == 1 ? 'destacada' : ''} titulo">
                    <h2>${post.titulo}</h2>
                </div>
                ${(post.autor != undefined && post.autor != null && post.autor.id != undefined && post.autor.id != null && post.autor.id > 0 && post.autor.nombre != undefined && post.autor.nombre !== "") ?
                    `<div class="persona">
                            <a href="${Utilities.formatoUrlAcuAutor(post.autor.nombre, post.autor.id)}" class="figure">${(post.autor.imagenId != undefined && post.autor.imagenId != null && post.autor.imagenId > 0) ? `<img src="${BucketTools.urlBucketBalance(urlBucket, post.autor.imagenId, "", 90, post.autor.imagenExtension)}"/>` : ''}</a>
                            <a href="${Utilities.formatoUrlAcuAutor(post.autor.nombre, post.autor.id)}">${post.autor.nombre}</a>
                    </div>`
                    : ''}
                <p>${post.texto}</p>`;
   
    //tipo de IDS 1=imagen, 2=video, 3=embeed, 4= cita
    switch(post.tipo){
    case 1:
        const imagen = post.imagen;
        html += `<figure class="L epigrafe" id="figure_${imagen.id}" data-is="imagen">                                                       
                            <picture>
                                <source media="(min-width: 768px)" srcset="${BucketTools.urlBucketBalance(urlBucket, imagen.id, "", 740, "jpg")}">
                                <source media="(min-width: 380px)" srcset="${BucketTools.urlBucketBalance(urlBucket, imagen.id, "", 769, "jpg")}">
                                <img src="${BucketTools.urlBucketBalance(urlBucket, imagen.id, "", "", "jpg")}" alt="${imagen.epigrafe}" style="">
                            </picture>
                            <figcaption>                               
                            </figcaption>
                        </figure>`;
                    // <figcaption>
                    //<epigrafe>${imagen.epigrafe}</epigrafe>
                    //    <span class="fuente"> Fuente: AFP</span>
                    //    </figcaption>
        break;
    case 2:
        html += `<div class="externo Video">                        
                            <aside id="videoContainerVideo-${post.id}" class="videoAside"
                               data-video_id="${post.id}"
                               data-multimediofile_id="${post.id}"
                               data-jwkey="${post.video}"
                               data-multimediojwkey="${post.video}"
                               data-destacado=""
                               data-showads="1"
                               data-property="0"
                               data-videotag_home=""
                               data-arraytags=""
                               data-titulo="${post.titulo}"
                               data-contenedor="nota"></aside>                            
                        </div>`;                       
        break;
    case 3:
        html += `${post.embeed}`;
        break;
    case 4:
        html += `<div class="textual">
                            <div>${post.cita}</div>
                            ${(post.citaAutorNombre != undefined && post.citaAutorNombre != "" && post.citaAutorNombre != null) ? `<span>${post.citaAutorNombre}</span>` : ''}
                        </div>`;
        break;
    }
    html += `</article>`;

    return html;
}

const eliminarPost = (id, esClave) => {
    let article = document.querySelector('article[data-articleId="' + id + '"]');
    if (esClave === true) {
        document.querySelector('ol > li[name="' + article.getAttribute("id") + '"]').outerHTML = " ";
    }
    article.outerHTML = " ";
}

const updateArticle = () => {
    let data = JSON.parse(localStorage.getItem('liveBlog'));
    let hayNuevosPost = false;
    if (data != null && data.hayCambios === true) {
        for (var post of data.evento.posts) {
            let nodoArticle = document.querySelector('article[data-articleId="' + post.id + '"]');

            if (post.borrado === true) {
                eliminarPost(post.id, post.esClave);
            }else if (nodoArticle != null) {
                //si existe y se modifico se reemplaza el contenido
                nodoArticle.outerHTML = article(post, nodoArticle.getAttribute('id'));
            } else {
                if (post.esClave) {
                    let html = "";
                    //El menu se crea en caso que no exista y si hay un article clave.. se lo agrega al menu
                    if (document.querySelector('ol.menu-fixed') == null && post.esClave) {
                        html = crearlinksFlotantesPostClaves(post);
                        document.querySelector('section.noticias').insertAdjacentHTML('afterbegin', html);
                    } else {
                        html = updatelinksFlotantesPostClaves(post);
                        document.querySelector('ol.menu-fixed').insertAdjacentHTML('afterbegin', html);
                    }
                }
                let postsClave = document.querySelector('ol.menu-fixed') != null ? document.querySelector('ol.menu-fixed').getAttribute('data-ids') : null;
                //si hay un nuevo contenido, se lo agrego en primer posicion
                document.querySelector('section.noticias')
                    .insertAdjacentHTML('afterbegin', article(post, post.esClave === 1 ? postsClave : ''));
                hayNuevosPost = true;

            }
        } 
        hayNuevosPost ? document.querySelector('div[data-liveblogid]').previousSibling.scrollIntoView({ behavior: 'smooth' }) : '';
        localStorage.setItem('liveBlog', null);
        scriptRedesSociales();
    }
}

const alertaActualizacion = (data) => {
    if (data.hayCambios === true) {
        document.querySelector('div[data-versionLiveBlog]').setAttribute('data-versionLiveBlog', data.evento.version);
        document.querySelector('div[data-versionLiveBlog]').setAttribute('data-estado', data.evento.estado);
        localStorage.setItem('liveBlog', JSON.stringify(data));
        let botonActualizacion = document.querySelector('button.nuevos-contenidos');
        botonActualizacion.addEventListener('click', function() {
            updateArticle();
            botonActualizacion.setAttribute("style", "display:none");
        });
        botonActualizacion.setAttribute("style", " ");
    }
}

const renderArticle = (posts) => {
    let html = "";
    let postsClave = 0;
    posts = posts.sort((a, b) => {
        const aDate = new Date(a.fecha);
        const bDate = new Date(b.fecha);
        return bDate.getTime() - aDate.getTime();
    });

    for (let post of posts) {
        if (post.borrado == false) {
            html += article(post, postsClave);
            post.esClave == 1 ? postsClave++ : '';
        }
    }

    return html;
}

const scriptRedesSociales = () => {
    let scriptInsta = document.createElement("script");
    scriptInsta.type = "text/javascript";
    scriptInsta.src = "//www.instagram.com/embed.js";
    document.body.appendChild(scriptInsta);
    let scriptTwitter = document.createElement("script");
    scriptTwitter.type = "text/javascript";
    scriptTwitter.src = "https://platform.twitter.com/widgets.js";
    document.body.appendChild(scriptTwitter);

    var s = document.createElement("script");
    s.type = "text/javascript";
    s.src = "https://secure.widget.cloud.opta.net/v3/v3.opta-widgets.js";
    document.body.appendChild(s);
}

export const renderLiveBlog = (data) => {
    document.querySelector('div[data-versionLiveBlog]').setAttribute('data-versionLiveBlog', data.evento.version);
    document.querySelector('div[data-versionLiveBlog]').setAttribute('data-estado', data.evento.estado);
    data.evento.posts.sort((a, b) => {
        const aDate = new Date(a.fecha);
        const bDate = new Date(b.fecha);
        return bDate.getTime() - aDate.getTime();
    });
    let posts = data.evento.posts.filter(x => x.esClave == 1);

    let html = `<div class="cont-principal">
                    ${crearlinksFlotantesPostClaves(posts)}
                    <section class="noticias">             
                        ${renderArticle(data.evento.posts)}                   
                        <button class="nuevos-contenidos icon-actualizar" style="display:none">Hay nuevos Contenidos</button>
                    </section>
                </div>`;
    document.querySelector('div[data-liveblogId]').innerHTML = html;
    Functions.stylesNotaLiveBlog();
    scriptRedesSociales();

    if (data.evento.estado == 1) {
        let interval = setInterval(function() {
                if (document.querySelector('div[data-versionLiveBlog]').getAttribute('data-estado') == 2) {
                    clearInterval(interval);
                }
                actualizacionInfoLiveBlog();
            }, 30000);
    }
}

const actualizacionInfoLiveBlog = () => {
    let version = document.querySelector('div[data-versionLiveBlog]').getAttribute('data-versionLiveBlog');
    Ajax.get(urlApiLiveBlog + document.querySelector('div[data-liveblogId]').getAttribute('data-liveblogId') + '?version=' + version + '&timestamp=' + new Date().getTime())
        .then(rs => JSON.parse(rs))
        .then(alertaActualizacion);
}

const primerRenderLiveBlog = () => {
    Ajax.get(urlApiLiveBlog + document.querySelector('div[data-liveblogId]').getAttribute('data-liveblogId') + '?timestamp=' + new Date().getTime())
        .then(rs => JSON.parse(rs))
        .then(renderLiveBlog);
}

export const loadEventoLiveBlog = () => {
       primerRenderLiveBlog();
}


// WEBPACK FOOTER //
// ./Statics/scripts/nota/liveBlog.js